/*
 * @Author: ncz
 * @Date: 2023-02-23 16:57:02
 * @Description: 扩展应用支持的平台类型
 */

module.exports = {
  /** 电脑设备 */
  PC: 'pc',
  /** VR设备 */
  WEBXR: 'webxr',
  /** 移动设备 */
  MOBILE: 'mobile'
}